import { request } from 'ice';
import { VAS_SERVICE_API } from '@/const';

// 获取table数据
async function getPageList(data: object) {
  const res = await request.post(`${VAS_SERVICE_API}/valueAddedTask/list`, data);

  return {
    total: res.totalElements,
    list: res.list,
  };
}

// 批量认领
async function BatchClaim(data: object) {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/claim`, data);
}

// 标签打印
async function printOrder(data: object) {
  return await request.post('/print/print/pass/printLabel', data);
}

// 批量打印清单
async function batchPrintLabel(data: object) {
  return await request.post(`${VAS_SERVICE_API}/print/listLabel`, data);
}

// 批量打印清单
async function batchPrintLabelMF4PL(data: object) {
  return await request.post(`${VAS_SERVICE_API}/print/export`, data);
}

// 获取SKU打印数据
async function getSkuPrintData(data: object) {
  return await request.post(`${VAS_SERVICE_API}/print/getValueAddedList`, data);
}

/**
 * 查询tab count的数量
 */
const getTabCount = async (data: object) => {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/selectVConsignmentCount`, data);
};

/**
 * 获取当前查询条件下的待换标数量 ===》 data:12
 */
const getWaitingForLabelApi = async (data: object) => {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/getWaitingForLabel`, data);
};

/**
 * 完成换标
 */
const completeChangeLabelApi = async (data: string) => {
  return await request.get(`${VAS_SERVICE_API}/valueAddedTask/confirmLabelChangedSuccess?consignmentNo=${data}`);
};

/*
 * 获取客户组
 */

export const getAllGroups = async () => {
  return await request.get(`${VAS_SERVICE_API}/valueAddedTask/selectAllGroup`);
};

export {
  getPageList,
  BatchClaim,
  printOrder,
  batchPrintLabel,
  batchPrintLabelMF4PL,
  getSkuPrintData,
  getTabCount,
  getWaitingForLabelApi,
  completeChangeLabelApi,
};
